/** @jsxImportSource preact */
import { useAuth } from '../providers/auth'
import { config } from '../config'

export function Dashboard() {
  const { user, logout } = useAuth()

  if (!user) {
    return null
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">PLT Ops App</h1>

      <div className="mb-6">
        <p className="text-gray-600">Hello, {user.email}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Loss Recovery</h2>
          <p className="text-gray-600 mb-4">Manage defaulted bookings and perform loss recovery actions.</p>
          <a
            href={config.routePrefix + '/loss-recovery'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Loss Recovery
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Change And Cancellation</h2>
          <p className="text-gray-600 mb-4">Perform booking change & cancellation actions.</p>
          <a
            href={config.routePrefix + '/change-and-cancellation'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to CCM
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">General</h2>
          <p className="text-gray-600 mb-4">View booking emails and notes.</p>
          <a
            href={config.routePrefix + '/general'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to General
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Customer Service</h2>
          <p className="text-gray-600 mb-4">Record financial compensation for a booking.</p>
          <a
            href={config.routePrefix + '/customer-service'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Customer Service
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Payments</h2>
          <p className="text-gray-600 mb-4">Review payment extensions for bookings.</p>
          <a
            href={config.routePrefix + '/payments'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Payments
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">E-Tickets</h2>
          <p className="text-gray-600 mb-4">Manage and upload e-tickets for bookings.</p>
          <a
            href={config.routePrefix + '/etickets'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to E-Tickets
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Accept ASC</h2>
          <p className="text-gray-600 mb-4">Process automated schedule changes for bookings.</p>
          <a
            href={config.routePrefix + '/asc'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to ASC
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">KYC and Eligibility Checks</h2>
          <p className="text-gray-600 mb-4">Finalise manual KYC and eligibility checks for bookings.</p>
          <a
            href={config.routePrefix + '/fraud'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to checks
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">NDC Price Drift</h2>
          <p className="text-gray-600 mb-4">Approve or decline NDC price-drift reviews before ticketing.</p>
          <a
            href={config.routePrefix + '/ndc-price-drift'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to NDC Price Drift
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Create</h2>
          <p className="text-gray-600 mb-4">Finalise create related reviews.</p>
          <a
            href={config.routePrefix + '/create'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Create
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Bulk Ticketed Outside Ops App</h2>
          <p className="text-gray-600 mb-4">Close Create reviews for bookings already ticketed outside the Ops App.</p>
          <a
            href={config.routePrefix + '/create/bulk-ticketed-outside'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Bulk Close
          </a>
        </div>

        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Refunds</h2>
          <p className="text-gray-600 mb-4">Calculate and process booking refunds.</p>
          <a
            href={config.routePrefix + '/refunds'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Refunds
          </a>
        </div>
        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Bulk Close Refunds</h2>
          <p className="text-gray-600 mb-4">Close refunds that were never coming, a list at a time.</p>
          <a
            href={config.routePrefix + '/refunds/bulk-close'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Bulk Close
          </a>
        </div>
        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
          <h2 className="text-lg font-semibold mb-2">Refund Protect</h2>
          <p className="text-gray-600 mb-4">Inspect a booking's Refund Protect policy.</p>
          <a
            href={config.routePrefix + '/refund-protect'}
            className="inline-block px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700"
          >
            Go to Refund Protect
          </a>
        </div>
      </div>

      <div className="text-center">
        <button
          onClick={() => logout()}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
